/* eslint-disable react/require-default-props */
import CircleIcon from "@mui/icons-material/Circle";
import { Box, Typography, Tooltip, Divider } from "@mui/material";
import { useTheme } from "@mui/styles";
import React from "react";
import { FormattedMessage } from "react-intl";
import InfoOutlinedIcon from "../../icons/InfoOutlinedIcon";
import AnswerNormalQuizBoard from "./AnswerNormalQuizBoard";
import { AnswerQuizPDF } from "./DisplayQuizPDF";

type TypeResultBoard = {
  quizInfoSolutions?: any;
  scrollFunc?: any;
  showSolutionPDF?: any;
  quizOpeningViewTypePDF?: boolean;
  dataList?: any;
  isDialog?: boolean;
};
export const ResultBoard = React.memo(
  ({ quizInfoSolutions, scrollFunc, quizOpeningViewTypePDF, showSolutionPDF, dataList, isDialog }: TypeResultBoard) => {
    const theme: any = useTheme();
    return (
      <Box className={`card-side md:w-[250px] lg:w-[298px] py-0 ${isDialog ? "px-2" : "md:px-0 lg:px-2"} `}>
        <span className={`flex justify-between text-[18px] font-semibold ${isDialog ? "py-2" : ""}`}>
          <FormattedMessage id="IDS_Detail" />
          {quizOpeningViewTypePDF && !isDialog && (
            <Tooltip
              placement="top-start"
              title={
                <Typography fontSize={12}>
                  <FormattedMessage id="IDS_TOOLTIP_ANSWER" />
                </Typography>
              }
              enterTouchDelay={0}
              arrow
            >
              <span>
                <InfoOutlinedIcon />
              </span>
            </Tooltip>
          )}
        </span>
        <Divider />
        {quizOpeningViewTypePDF ? (
          <AnswerQuizPDF
            dataList={dataList}
            resultSolution={quizInfoSolutions?.results}
            showSolutionPDF={showSolutionPDF}
            isDialog={isDialog}
          />
        ) : (
          <AnswerNormalQuizBoard
            dataList={dataList}
            resultSolution={quizInfoSolutions?.results}
            scrollFunc={scrollFunc}
            isDialog={isDialog}
          />
        )}
        <Box display="flex" flexDirection="column" className="text-[13px]">
          <Box display="flex" alignItems="center" mt={2}>
            <CircleIcon fontSize="small" className="svgFillAll" style={{ color: theme.answerOptions.correct }} />
            <span style={{ marginLeft: 8 }}>
              <FormattedMessage id="DialogSolutionGuiding.rightAnswer" />
            </span>
          </Box>
          <Box display="flex" alignItems="center" mt={2}>
            <CircleIcon fontSize="small" className="svgFillAll" style={{ color: theme.answerOptions.purple }} />
            <span style={{ marginLeft: 8 }}>
              <FormattedMessage id="DialogSolutionGuiding.rightAnswerMissing" />
            </span>
          </Box>
          <Box display="flex" alignItems="center" mt={2}>
            <CircleIcon fontSize="small" style={{ color: theme.answerOptions.inCorrect }} />
            <span style={{ marginLeft: 8 }}>
              <FormattedMessage id="DialogSolutionGuiding.wrongAnswer" />
            </span>
          </Box>
          <Box display="flex" alignItems="center" mt={2}>
            <CircleIcon fontSize="small" style={{ color: theme.answerOptions.skipped }} />
            <span style={{ marginLeft: 8 }}>
              <FormattedMessage id="DialogSolutionGuiding.skippedAnswer" />
            </span>
          </Box>
        </Box>
        <Divider className="mt-[20px] mb-2" sx={{ borderBottomWidth: 3 }} />
      </Box>
    );
  }
);
